<button
class="export-button text-hidden text-unhide-hover"
mat-stroked-button
siteUsageTracker
[logCategory]="'ExportToExcelButton'"
[logName]="'ExportClick'"
matTooltip="{{ 'General.Information.ExportTooltip' | translate }}"
>
<svg-icon style="padding-bottom: 5px;"
  src="assets/svg/export-to-excel.svg"
></svg-icon>
  <span class="button-text">{{ 'General.Information.Excel' | translate }}</span>
</button>
